// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";

export function WarningIcon() {
  return (
    <span style={{ margin: "0 5px" }} role="img" aria-label="warning">
      ⚠️
    </span>
  );
}
